// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"01c006ce","488":"60a34780","732":"a123f61a","977":"dd6f036f"}[chunkId] + ".chunk.js";
};